module.exports = __webpack_public_path__ + "static/media/stream_modelFit_video_classes.3960fb8e.svg";